<template>
  <div
    :id="patchGroupElementId"
    class="patch-group"
  >
    <h5 class="patch-group__header">{{ patchGroup.Name }}</h5>
    <div class="row">
      <div
        v-for="patch in patchGroup.patches"
        :key="patch.Id"
        class="col-xs-6 col-sm-4 col-lg-2"
        @click="handlePatchClick(patch)"
      >
        <div class="patch-group__patch-item">
          <img
            :src="patchImageUrlResized(patch.Image.File.Url)"
            :class="imageClasses(patch)"
          >
          <div class="text-center patch-group__patch-item-name">
            {{ patchName(patch) }}
          </div>
          <div>
            <button
              type="button"
              class="button text-center patch-group__patch-item-btn"
            >Select</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'PatchGroupListing',
  props: {
    patchGroup: { type: Object, default: null, required: true },
    patchGroupElementId: { type: String, default: null, required: true },
    selectedPatch: { type: Object, default: null }
  },
  methods: {
    imageClasses (patch) {
      return {
        'patch-group__patch-item-image': true,
        'patch-group__patch-item-image--selected': this.selectedPatch !== null && patch.Id === this.selectedPatch.Id
      }
    },
    patchImageUrlResized (patchImageUrl) {
      return `${patchImageUrl}?w=125&h=125`
    },
    patchName (patch) {
      if (patch.RetailName !== null) {
        return patch.RetailName
      }

      return patch.Name
    },
    handlePatchClick (patch) {
      GoogleAnalytics.trackEvent(
        'Select Patch Modal Patch',
        'click',
        patch.Name
      )

      this.$emit('patch-selected', patch)
    }
  }
}
</script>

<style lang="scss" scoped>
.patch-group {
  margin-bottom: 20px;

  &__header {
    border: none;
    font-size: 30px;
    font-weight: 600;
  }

  &__patch-item {
    cursor: pointer;
    margin-bottom: 40px;

    &-image {
      border: 1px solid #e5e4e5;
      height: 125px;
      width: 125px;
      display: block;
      margin: 0 auto 10px auto;

      &--selected {
        border: 4px solid $letterjacket-color-blue;
      }
    }

    &-name {
      font-size: 16px;
      height: 66px;
      line-height: 22px;
      margin-bottom: 10px;
    }

    &-btn {
      background-color: #fff;
      border: 2px solid $letterjacket-color-blue;
      color: $letterjacket-color-blue;
      font-size: 14px;
      font-weight: normal;
      height: auto;
      line-height: 18px;
      margin: 0;
      padding: 4px 0;
      text-align: center;
      width: 100%;

      &:hover {
        background-color: $letterjacket-color-blue;
        color: #fff;
      }
    }
  }

  @media screen and (min-width: $screen-lg-min) {
    &__patch-item {
      &-image {
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/SleevePatchSelection/SleevePatchSelectionModal/PatchGroupListing.vue